<template>
    <div>
        <modal-enviar-regulacao v-if="showModalEnviarRegulacao" @close="showModalEnviarRegulacao = false" @enviaRegulacao="motivo => enviaRegulacao(motivo)"></modal-enviar-regulacao>
        <div class="row">
            <div class="col-sm-6">
                <div class="divListVagas">
                    <div class="panel panel-default panel-table overflow-box">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col col-xs-12">
                                    <h3 class="panel-title"><b>Selecione uma unidade</b></h3>
                                </div>
                            </div>
                        </div>
                        <div>
                            <ul class="listsVagas tamanho-fixo-agenda-cima">
                                <li v-for="(item, index) in vagas_unidade" :key="index" @click="getAtendimentosByUnidade(item[0].unidade_id)">
                                    <a :class="{ ativa: selecionados.indexUnidadeAtiva === item[0].unidade_id }" class="list-group-item list-group-item-action list-group-item-warning">
                                        <strong> {{ getQtdProcedimentosAtendidos(item[0].unidade_id) }} </strong> {{ item[0].unidade.nome | uppercase }}<br />
                                        <span> </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="divListVagas">
                    <div class="panel panel-default panel-table">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col col-xs-12">
                                    <h3 class="panel-title" style="cursor: pointer;"><b>Selecione uma data</b></h3>
                                </div>
                            </div>
                        </div>
                        <div style="height: 260px;">
                            <date-picker @dp-change="getUnidadesByDia" v-if="optionsCalendario.enabledDates" v-model="selecionados.data" :config="optionsCalendario"></date-picker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- fim da row -->

        <div class="row">
            <div class="col-sm-6">
                <div class="divListVagas">
                    <div class="panel panel-default panel-table overflow-box">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col col-xs-12">
                                    <h3 class="panel-title"><b>Atendimentos da Unidade</b></h3>
                                </div>
                            </div>
                        </div>
                        <div>
                            <ul class="listsVagas tamanho-fixo-agenda-cima">
                                <li v-for="(item, index) in atendimentos_unidade" :key="index">
                                    <a style="cursor: default" class="list-group-item list-group-item-action list-group-item-warning"> {{ item[0].procedimento_nome | uppercase }}<br /> </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="divListVagas">
                    <div class="panel panel-default panel-table overflow-box">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col col-xs-12">
                                    <h3 class="panel-title"><b>Procedimentos</b></h3>
                                </div>
                            </div>
                        </div>
                        <div>
                            <ul class="listsVagas tamanho-fixo-agenda-cima">
                                <li v-for="(item, index) in procedimentos" :key="index">
                                    <a v-if="item.ativo" style="cursor: default" class="list-group-item list-group-item-action list-group-item-success">
                                        <i class="fa fa-check"></i>
                                        <strong> {{ item.procedimento_nome | uppercase }} </strong><br />
                                        <span
                                            >Unidade: <strong> {{ item.unidade.nome | uppercase }} </strong></span
                                        ><br />
                                        <span
                                            >Data: <strong>{{ item.data_atendimento | dataFormatada }}</strong> à partir das <b>{{ item.hora_inicial | horaFormatada }}</b> horas.</span
                                        ><br />
                                    </a>
                                    <a v-else style="cursor: default" class="list-group-item list-group-item-action list-group-item-warning">
                                        <i class="fa fa-exclamation-triangle"></i>
                                        <strong>{{ item.procedimento_nome | uppercase }}</strong
                                        ><br />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		<br>
        <div class="row">
            <div class="col-md-12 margin-bottom">
                <span class="pull-left">
                    <button @click="selecionaProcedimentos()" class="pull-left btn btn-default">Selecionar <i class="fa fa-arrow-right"></i></button>
                </span>
                <span class="pull-right">
                    <button @click="confirma" v-if="!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao" class="btn btn-success" :disabled="disableBtConfirmar"><i class="fa fa-check"> Confirmar</i></button>
                    <button @click="informacaoPendente" v-if="this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao" class="btn btn-info"><i class="fa fa-comment"></i> Solicitar informação pendente</button>
                    <button @click="negativar" v-if="this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao" class="btn btn-danger"><i class="fa fa-times-circle"></i> Negativar</button>
                    <button @click="confirma" v-if="this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao" class="btn btn-success"><i class="fa fa-check"></i> Regular</button>
                    <button @click="showModalEnviarRegulacao = true" v-if="!this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao" class="btn btn-warning"><i class="fa fa-send"></i> Regulação</button>
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div style="text-align:left; margin-bottom:20px;">
                    <button @click="$router.go(-1)" class="btn btn-default"><i class="fa fa-reply"></i> Voltar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import groupBy from "json-groupby";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
// import moment from 'moment';

import axios from "axios"; // Cliente para requisição http
import { SITUACAO_SOLICITACAO } from "@/constants";

import modalEnviarRegulacao from "./modalEnviarRegulacao";

export default {
    props: ["vagasApi", "solicitacaoId"],
    computed: {
        SITUACAO_SOLICITACAO: function() {
            return SITUACAO_SOLICITACAO;
        }
    },
    data: () => ({
        showModalEnviarRegulacao: false,
        disableBtConfirmar: true,
        optionsCalendario: {
            format: "YYYY-MM-DD",
            useCurrent: false,
            inline: true,
            locale: "pt-br",
            enabledDates: null,
            defaultDate: false
        },
        filtros: {
            pesquisa: "",
            coluna: null,
            ordem: null
        },

        selecionados: {
            indexUnidadeAtiva: null,
            data: null,
            procedimentos: []
        },

        vagas_unidade: [],
        atendimentos_unidade: [],
        procedimentos: [],
        vagas: [],
        dados: { observacao: "" }
    }),
    created() {},

    methods: {
        negativar() {
            this.$swal({
                title: `Justificativa da negativa:`,
                type: "error",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: value => {
                    return !value && "Insira a justificativa!";
                },
                preConfirm: observacao => {
                    this.dados.observacao = observacao;
                }
            }).then(result => {
                this.$store.commit("TOGGLE_LOADING");
                this.dados.solicitacaoId = this.$props.solicitacaoId;
                if (result.value) {
                    axios
                        .post(`${this.$store.state.serverURI}/api/atendimentos/negativar`, this.dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            this.$store.commit("TOGGLE_LOADING");
                            this.$swal({
                                type: "success",
                                title: "Solicitação negativada com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.$router.go(-2);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
        },
        informacaoPendente() {
            this.dados.situacao = this.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE;
            this.$swal({
                title: `Mensagem para o marcador:`,
                type: "info",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-paper-plane"></i> Enviar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: value => {
                    return !value && "Insira a mensagem!";
                },
                preConfirm: observacao => {
                    this.dados.observacao = observacao;
                }
            }).then(result => {
				let loader = this.$loading.show()
                this.$store.commit("TOGGLE_LOADING");
                this.dados.solicitacaoId = this.$props.solicitacaoId;
                if (result.value) {
                    axios
                        .post(`${this.$store.state.serverURI}/api/atendimentos/atualizarSituacao`, this.dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
							loader.hide()
                            this.$store.commit("TOGGLE_LOADING");
                            this.$swal({
                                type: "success",
                                title: "Mensagem enviada com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.$router.go(-2);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
        },
        confirma() {
            let obj = this.procedimentos;
            this.$emit("confirma", obj);
        },
        enviaRegulacao(motivo) {
            this.showModalEnviarRegulacao = false;
            let obj = this.procedimentos;
            this.$emit("enviaRegulacao", obj, motivo);
        },
        formataVagas: function() {
            let vagas = [];
            this.vagasApi.map((item, indice) => {
                item.map(atendimento => {
                    vagas.push({
                        procedimento_id: atendimento.procedimento_id,
                        procedimento_nome: atendimento.procedimento_nome,
                        atendimento_id: atendimento.id,
                        contrato_procedimento_id: atendimento.distribuicao_contrato_procedimento_id,
                        quantidade: atendimento.quantidade_primeira ? atendimento.quantidade_primeira : atendimento.quantidade_atendimento,
                        hora_inicial: atendimento.hora_inicial,
                        hora_final: atendimento.hora_final,
                        data_atendimento: atendimento.data_atendimento,
                        profissional_id: atendimento.profissional_id ? atendimento.profissional_id : -1,
                        unidade_id: atendimento.contrato_procedimento ? atendimento.contrato_procedimento.contrato.unidade_id : atendimento.contrato_subgrupo.contrato.unidade_id,
                        profissional: {
                            nome: atendimento.profissional_id ? atendimento.profissional.nome : "SEM PROFISSIONAL"
                        },
                        unidade: {
                            nome: atendimento.contrato_procedimento ? atendimento.contrato_procedimento.contrato.unidade.nome : atendimento.contrato_subgrupo.contrato.unidade.nome
                        },
                        tipoVaga: item.contrato_procedimento ? "procedimento" : "subgrupo"
                    });
                });
            });

            this.vagas = vagas;
            this.$nextTick(() => {
                this.getDias();
                this.getProcedimentos();
            });
        },
        selecionaProcedimentos() {
            let atendimentosIndex = Object.keys(this.atendimentos_unidade);

            this.procedimentos.map(procedimento => {
                atendimentosIndex.map(indice => {
                    // if (procedimento.procedimento_id == indice) {
                    this.disableBtConfirmar = false;
                    procedimento.ativo = false;
                    procedimento.atendimento_id = null;
                    procedimento.hora_inicial = null;
                    procedimento.hora_final = null;
                    procedimento.data_atendimento = null;
                    procedimento.profissinal_id = null;
                    procedimento.unidade_id = null;
                    procedimento.profissional = null;
                    procedimento.unidade = null;
                    // }
                });
            });

            this.procedimentos.map(procedimento => {
                atendimentosIndex.map(indice => {
                    if (procedimento.procedimento_id == indice) {
                        this.disableBtConfirmar = false;
                        procedimento.ativo = true;
                        procedimento.atendimento_id = this.atendimentos_unidade[indice][0]["atendimento_id"];
                        procedimento.hora_inicial = this.atendimentos_unidade[indice][0]["hora_inicial"];
                        procedimento.hora_final = this.atendimentos_unidade[indice][0]["hora_final"];
                        procedimento.data_atendimento = this.atendimentos_unidade[indice][0]["data_atendimento"];
                        procedimento.profissinal_id = this.atendimentos_unidade[indice][0]["profissinal_id"];
                        procedimento.unidade_id = this.atendimentos_unidade[indice][0]["unidade_id"];
                        procedimento.profissional = this.atendimentos_unidade[indice][0]["profissional"];
                        procedimento.unidade = this.atendimentos_unidade[indice][0]["unidade"];
                    }
                });
            });
        },
        getDias() {
            this.optionsCalendario.enabledDates = null;
            this.selecionados.data = null;

            let vagasDias = groupBy(this.vagas, ["data_atendimento"]);
            this.$nextTick(() => {
                this.optionsCalendario.enabledDates = Object.keys(vagasDias);
                this.selecionados.data = Object.keys(vagasDias)[0];
                this.getUnidadesByDia();
            });
        },
        getProcedimentos() {
            this.procedimentos = [];
            let procedimentos = groupBy(this.vagas, ["procedimento_id"]);
            let indexProcedimentos = Object.keys(procedimentos);

            let procedimentosArray = [];
            indexProcedimentos.map((indice, index) => {
                let obj = {
                    ...procedimentos[indice][0],
                    ativo: false
                };
                procedimentosArray.push(obj);
            });
            this.procedimentos = procedimentosArray;
        },

        getUnidadesByDia() {
            this.atendimentos_unidade = [];
            let vagasUnidade = [];
            this.vagas.map(vaga => {
                if (vaga.data_atendimento == this.selecionados.data) {
                    vagasUnidade.push(vaga);
                }
            });
            this.$nextTick(() => {
                let temp = groupBy(vagasUnidade, ["unidade_id"]);
                this.vagas_unidade = temp;
                let indices = Object.keys(temp);
                this.getAtendimentosByUnidade(temp[indices[0]][0].unidade_id);
            });
        },

        getAtendimentosByUnidade(unidadeId) {
            // this.selecionados.procedimentos = [];
            this.selecionados.indexUnidadeAtiva = unidadeId;
            let atendimentosUnidade = [];
            this.vagas.map(vaga => {
                if (vaga.unidade_id == unidadeId && vaga.data_atendimento == this.selecionados.data) {
                    atendimentosUnidade.push(vaga);
                }
            });
            this.atendimentos_unidade = groupBy(atendimentosUnidade, ["procedimento_id"]);
        },

        sortByKey: function(field) {
            this.dados.coluna = field;
            if (this.dados.ordem == "asc") {
                this.dados.ordem = "desc";
            } else {
                this.dados.ordem = "asc";
            }
        },

        getQtdProcedimentosAtendidos(unidadeId) {
            let qtdProcedimentos = this.vagasApi.length;
            let qtdAtendidas = 0;
            this.vagas.map(vaga => {
                if (vaga["unidade_id"] == unidadeId && vaga["data_atendimento"] == this.selecionados.data) {
                    qtdAtendidas++;
                }
            });
            return qtdAtendidas + "/" + qtdProcedimentos;
        }
    },
    watch: {
        page: function(val) {
            this.getDataTable();
        },
        vagasApi: function(newValue) {
            this.formataVagas();
        }
    },

    components: {
        datePicker,
        modalEnviarRegulacao
    }
};
</script>
<style scoped>
.listsVagas {
    list-style-type: none;
    display: inline;
    padding: 0px;
}

.listsVagas a {
    padding: 5px 10px 5px 10px;
    cursor: pointer;
}

.list-group-item {
    border-radius: 0px;
}

.tamanho-fixo-agenda-cima {
    display: block;
    height: 250px;
}

.ativa {
    background-color: #fdf59a !important;
    color: #333;
}
.ativa:hover {
    background-color: #fdf59a !important;
    color: #333;
}
.panel {
    margin-bottom: 5px;
}

.procedimentoSelecionado {
    background-color: #fdf59a !important;
    color: #333;
}

.overflow-box {
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// resolucaoAgrupado.vue?65bd11eb